/**
 * @generated SignedSource<<3405ced86ad0f624c13755c10fc7658a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InfoServicePage_page$data = {
  readonly breadcrumbs: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"Breadcrumb_data">;
  } | null | undefined> | null | undefined;
  readonly components: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly " $fragmentSpreads": FragmentRefs<"AboManager_component" | "SubscriptionIntroduction_component">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly path: string | null | undefined;
  readonly retailOnly: {
    readonly " $fragmentSpreads": FragmentRefs<"LabeledSelectBox_labeledSelectBox">;
  };
  readonly salesadmission: {
    readonly " $fragmentSpreads": FragmentRefs<"LabeledSelectBox_labeledSelectBox">;
  } | null | undefined;
  readonly " $fragmentType": "InfoServicePage_page";
};
export type InfoServicePage_page$key = {
  readonly " $data"?: InfoServicePage_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"InfoServicePage_page">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "LabeledSelectBox_labeledSelectBox"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "retailOnly"
    },
    {
      "defaultValue": "AT",
      "kind": "LocalArgument",
      "name": "salesAdmission"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "InfoServicePage_page",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LabeledSelectBox",
      "kind": "LinkedField",
      "name": "salesadmission",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LabeledSelectBox",
      "kind": "LinkedField",
      "name": "retailOnly",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "ComponentConnection",
      "kind": "LinkedField",
      "name": "components",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ComponentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SubscriptionIntroduction_component"
                },
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "retailOnly",
                      "variableName": "retailOnly"
                    },
                    {
                      "kind": "Variable",
                      "name": "salesAdmission",
                      "variableName": "salesAdmission"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "AboManager_component"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "components(first:1000)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Breadcrumb",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Breadcrumb_data"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "InfoServicePage",
  "abstractKey": null
};
})();

(node as any).hash = "d02abc203406be6bebb6101ac3e9fa36";

export default node;
